import { render, staticRenderFns } from "./Attribute2.vue?vue&type=template&id=5563ecc6&scoped=true"
import script from "./Attribute2.vue?vue&type=script&lang=js"
export * from "./Attribute2.vue?vue&type=script&lang=js"
import style0 from "./Attribute2.vue?vue&type=style&index=0&id=5563ecc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563ecc6",
  null
  
)

export default component.exports